import { render } from "./InvitationModal.vue?vue&type=template&id=4f08fa29"
import script from "./InvitationModal.vue?vue&type=script&lang=js"
export * from "./InvitationModal.vue?vue&type=script&lang=js"

import "./InvitationModal.vue?vue&type=style&index=0&id=4f08fa29&lang=css"
script.render = render

export default script